import { z } from "zod";
import { DateValidation } from "../shared/date-validation";
import { ProductItemSchema } from "../product/product-item";

export const BillingInvoiceProductItemSchema = z.object({
  Id: z.string(),
  Created: DateValidation,
  Product: ProductItemSchema.optional(),
  LineItemNumber: z.number().optional(),
  LineTypeCode: z.number().optional(),
  ProductName: z.string().optional(),
  ProductNumber: z.string().optional(),
  ProductTypeCode: z.number().optional(),
  Quantity: z.number().optional(),
  ManualDiscountAmount: z.number().optional(),
  PricePerUnit: z.number().optional(),
  ExtendedAmount: z.number().optional(),
  BaseAmount: z.number().optional(),
  CurrencyId: z.string().optional(),
  UnitOfMeasureId: z.string().optional(),
  SalesOrderDetailId: z.string().optional(),
  ProductId: z.string().optional(),
  InvoiceId: z.string().optional(),

  IsCopied: z.boolean().optional(),
  IsPriceOverridden: z.boolean().optional(),
  IsProductOverridden: z.boolean().optional(),
  msdyn_IncludeExpense: z.boolean().optional(),
  msdyn_IncludeFee: z.boolean().optional(),
  msdyn_IncludeMaterial: z.boolean().optional(),
  msdyn_IncludeTime: z.boolean().optional(),
  PricingErrorCode: z.number().optional(),
  PropertyConfigurationStatus: z.number().optional(),
  SalesOrderDetailName: z.string().optional(),
  SalesOrderIsPriceLocked: z.boolean().optional(),
  SkipPriceCalculation: z.number().optional(),
  SalesOrderId: z.string().optional(),
  QuoteDetailId: z.string().optional(),
});

export type BillingInvoiceProductItemType = z.infer<
  typeof BillingInvoiceProductItemSchema
>;
